import appApi from '../../../../../../../api/app-api';
import { HourChangeRequestStatusType } from '../../../../../../../api/types/programs/course/course-hours-request-change/course-hours-request-change.type';

export const updateHourChangeRequestStatus = async (
  programId: number,
  courseId: number,
  requestId: number,
  status: HourChangeRequestStatusType,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);
    await appApi.updateCourseHoursRequestStatus(
      programId,
      courseId,
      requestId,
      status,
    );
  } catch (error) {
    console.error('Error updating hour change request status:', error);
    throw error;
  } finally {
    setLoading(false);
  }
};
